export { default as BadgeWrapper } from './BadgeWrapper'
export { default as Badge } from './Badge'
export type { BadgeProps, BadgeComponentType } from './types'
export { BadgeStyle, BadgeSize, BadgeSurfaceColor } from './types'
